export default __webpack_public_path__ + "static/media/StartFXProcess.66e04ac2.png";